
export const customertypes = state => {
  return state.customertypes
}
export const activecustomertypes = state => {
  return state.activecustomertypes
}
export const jobtitles = state => {
  return state.jobtitles
}
export const activejobtitles = state => {
  return state.activejobtitles
}
export const salutations = state => {
  return state.salutations
}
export const activesalutations = state => {
  return state.activesalutations
}
export const regions = state => {
  return state.regions
}
export const activeregions = state => {
  return state.activeregions
}
export const mbpbranches = state => {
  return state.mbpbranches
}
export const activembpbranches = state => {
  return state.activembpbranches
}
export const salesexecs = state => {
  return state.salesexecs
}
export const activesalesexecs = state => {
  return state.activesalesexecs
}
export const opportunitystatuses = state => {
  return state.opportunitystatuses
}
export const activeOpportunityStatuses = state => {
  return state.activeOpportunityStatuses
}
export const quotestatuses = state => {
  return state.quotestatuses
}
export const activequotestatuses = state => {
  return state.activequotestatuses
}
export const activitystatuses = state => {
  return state.activitystatuses
}
export const activeactivitystatuses = state => {
  return state.activeactivitystatuses
}
export const activityTypes = state => {
  return state.activityTypes
}
export const activeactivitytypes = state => {
  return state.activeactivitytypes
}
export const activeremindertypes = state => {
  return state.activeremindertypes
}
export const activityresults = state => {
  return state.activityresults
}
export const activeactivityresults = state => {
  return state.activeactivityresults
}
export const producttypes = state => {
  return state.producttypes
}
export const activeproducttypes = state => {
  return state.activeproducttypes
}
export const projecttypes = state => {
  return state.projecttypes
}
export const activeprojecttypes = state => {
  return state.activeprojecttypes
}
export const lostquotenotes = state => {
  return state.lostquotenotes
}
export const activelostquotenotes = state => {
  return state.activelostquotenotes
}
export const datemodifiers = state => {
  return state.datemodifiers
}
export const users = state => {
  return state.users
}
export const activeusers = state => {
  return state.activeusers
}
export const citiesTowns = state => {
  return state.citiesTowns
}
export const activeCitiesTowns = state => {
  return state.activeCitiesTowns
}
export const roles = state => {
  return state.roles
}
export const activeRoles = state => {
  return state.activeRoles
}
export const favoriteFilters = state => {
  return state.favoriteFilters
}
export const jobfunctions = state => {
  return state.jobfunctions
}
export const mbpDepartments = state => {
  return state.mbpDepartments
}
export const quotationGrades = state => {
  return state.quotationGrades
}
export const activeQuotationGrades = state => {
  return state.activeQuotationGrades
}
export const userWidgets = state => {
  return state.userWidgets
}
export const opportunities = state => {
  return state.opportunities
}
export const mbpdepts = state => {
  return state.mbpdepts
}
export const contacttypes = state => {
  return state.contacttypes
}
export const activequotations = state => {
  return state.activequotations
}
export const parentcustomernames = state => {
  return state.parentcustomernames
}
export const contacts = state => {
  return state.contacts
}
export const customernames = state => {
  return state.customernames
}



export const columnsSelection1 = state => {
  return state.columnsSelection1
}
export const columnsSelection2 = state => {
  return state.columnsSelection2
}
export const columnsSelection3 = state => {
  return state.columnsSelection3
}
export const columnsSelection4 = state => {
  return state.columnsSelection4
}
export const columnsSelection5 = state => {
  return state.columnsSelection5
}
export const columnsSelection6 = state => {
  return state.columnsSelection6
}
export const columnsSelection7 = state => {
  return state.columnsSelection7
}
export const columnsSelection8 = state => {
  return state.columnsSelection8
}
export const columnsSelection12 = state => {
  return state.columnsSelection12
}
export const columnsSelection101 = state => {
  return state.columnsSelection101
}
export const columnsSelection102 = state => {
  return state.columnsSelection102
}


export const dbViewFields1 = state => {
  return state.dbViewFields1
}
export const dbViewFields2 = state => {
  return state.dbViewFields2
}
export const dbViewFields3 = state => {
  return state.dbViewFields3
}
export const dbViewFields4 = state => {
  return state.dbViewFields4
}
export const dbViewFields5 = state => {
  return state.dbViewFields5
}
export const dbViewFields6 = state => {
  return state.dbViewFields6
}
export const dbViewFields7 = state => {
  return state.dbViewFields7
}
export const dbViewFields8 = state => {
  return state.dbViewFields8
}
export const dbViewFields12 = state => {
  return state.dbViewFields12
}
export const dbViewFields101 = state => {
  return state.dbViewFields101
}
export const dbViewFields102 = state => {
  return state.dbViewFields102
}


export const userViewFilters1 = state => {
  return state.userViewFilters1
}
export const userViewFilters2 = state => {
  return state.userViewFilters2
}
export const userViewFilters3 = state => {
  return state.userViewFilters3
}
export const userViewFilters4 = state => {
  return state.userViewFilters4
}
export const userViewFilters5 = state => {
  return state.userViewFilters5
}
export const userViewFilters6 = state => {
  return state.userViewFilters6
}
export const userViewFilters7 = state => {
  return state.userViewFilters7
}
export const userViewFilters8 = state => {
  return state.userViewFilters8
}
export const userViewFilters12 = state => {
  return state.userViewFilters12
}


export const defUserViewFilter1 = state => {
  return state.defUserViewFilter1
}
export const defUserViewFilter2 = state => {
  return state.defUserViewFilter2
}
export const defUserViewFilter3 = state => {
  return state.defUserViewFilter3
}
export const defUserViewFilter4 = state => {
  return state.defUserViewFilter4
}
export const defUserViewFilter5 = state => {
  return state.defUserViewFilter5
}
export const defUserViewFilter6 = state => {
  return state.defUserViewFilter6
}
export const defUserViewFilter7 = state => {
  return state.defUserViewFilter7
}
export const defUserViewFilter8 = state => {
  return state.defUserViewFilter8
}
export const defUserViewFilter12 = state => {
  return state.defUserViewFilter12
}